import { IIdName } from "./i-id-name";
import { FormElementBase } from "../shared/form/form-element.base";

//export enum SystemTable {
//	AddressType = 1,
//	AreaType,
//	Brand,
//	City,
//	ConceptType,
//	ContractStatus,
//	ContractType,
//	ContractUnitClass,
//	ContractAction,
//	ContractGuarantee,
//	CostCenter,
//	Country,
//	DeliverableCategory,
//	DeliverableStatus,
//	DeliverableTemplate,
//	DeliverableTemplateType,
//	DeliverableType,
//	FacilityInventoryColumn,
//	FacilityInventoryType,
//	FacilityInventoryTypeColumn,
//	Industry,
//	InvestmentCategory,
//	InvestmentType,
//	LookupTable,
//	LookupTableSchema,
//	LookupTableValues,
//	OwnRegion,
//	Region,
//	PremisesLocationType,
//	ProjectAction,
//	ProjectInvestments,
//	ProjectStatus,
//	SiteType,
//	StoreClass,
//	StoreFormat,
//	StoreOperationType,

//	SiteSurveyCctvModel,
//	SiteSurveyCeilingType,
//	SiteSurveyDoorType,
//	SiteSurveyEasAlarmBrand,
//	SiteSurveyElevatorBrand,
//	SiteSurveyElevatorModel,
//	SiteSurveyEscalatorBrand,
//	SiteSurveyEscalatorModel,
//	SiteSurveyFloorMaterial,
//	SiteSurveyFloorSignage,
//	SiteSurveyFloorStorefront,
//	SiteSurveyFloorWindow,
//	SiteSurveyHeatingSupplier,
//	SiteSurveyHeatingType,
//	SiteSurveyHvacType,
//	SiteSurveyIncomingPowerType,
//	SiteSurveyInvestmentType,
//	SiteSurveyMaintenance,
//	SiteSurveyPelonSignageInvestor,
//	SiteSurveyPowerProvider,
//	SiteSurveySafeSafetyClass,
//	SiteSurveySignageType,
//	SiteSurveyStorefrontMaterial,
//	SiteSurveyTagModel,
//	SiteSurveyWallcoverMaterial,
//	SiteSurveyWindowLightType

//}

export interface ISystemTable {
    systemTable: String;
    title: string;
    group: string;
    hasIdentityColumn?: boolean;
    columns?: ISystemTableColumn[];
}

export interface ISystemTableColumn {
    name: string;
    dataType: string;
    isRequired?: boolean;
    isPrimaryKey?: boolean;
    isForeignKey?: boolean;
    isValueGenerated?: boolean;
    templates?: IIdName[];
    label?: string;
    sortOrder?: number;
    visible?: boolean;
    controlType?: string;
}

export interface ISystemTableRowItem {
    id: string;
    name: string;
    formElements: Array<FormElementBase<any>>;
    data: any;
}

export class SystemTableDataType {
    static readonly Integer = "integer";
    static readonly String = "string";
    static readonly Number = "number";
    static readonly Date = "date";
    static readonly Boolean = "boolean";
    static readonly Memo = "memo";
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/system-table.ts